const EN = {
    table: {
        columns: {
            id: 'ID',
            period: 'Period',
            amount: 'Amount',
            applies: 'Applies to',
            created: 'Creation Date',
            updated: 'Modification Date',
            status: 'Status',
        },
    },
    period: {
        day: 'Daily',
        month: 'Monthly',
    },
    levels: {
        1: 'Diamond',
        2: 'Sapphire',
        3: 'Gold',
        4: 'Silver',
        5: 'Bronze'
    },
    status: {
        0: 'Inactive',
        1: 'Active',
    }
};

export default EN;
